<template>
  <vk-modal :has-close-icon="closeIcon" @close="$emit('close')">
    <vk-modal-body class="MODAL">
      <vk-modal-header :class="['bd-b-gray30', {closeIcon: 'p-l-6'}]">
        <span>Filter</span>
      </vk-modal-header>
      <vk-modal-content>
        <div class="CONTENT">
          <div class="d-flex fd-column ">
            <div class="m-3 bd-b-gray50">
              <select-box
                  v-model="dataObj.selectedMonth"
                  :options=months
                  class="m-b-3"
                  option-label="label"
                  option-value="key"/>
            </div>
            <div>
              <div class="m-t-1">
                <div class="LABEL p-2 c-gray90">Types of points</div>
                <div
                    class="CHECK-INPUT"
                    v-for="transactionType in $options.TRANSACTION_TYPES"
                    :key="transactionType.type">
                  <div>
                    <input
                        class="input-check"
                        type="checkbox"
                        :value="transactionType.type"
                        v-model="dataObj.selectedPointTypes">
                    <label>
                      {{ transactionType.label }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vk-modal-content>
      <vk-modal-footer class="d-flex jc-center ai-center bd-t-gray30">
        <div class="BUTTONS w-100">
          <button @click="reset()" :disabled="isDisabled" class="m-r-1 bg-white btn-secondary">
            Clear All
          </button>
          <button @click="submit(dataObj)" :disabled="isDisabled" class="m-r-2 btn">
            Apply
          </button>
        </div>
      </vk-modal-footer>
    </vk-modal-body>
  </vk-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderMenuChevron from '@/layouts/components/HeaderMenuChevron';
import { TRANSACTION_TYPES } from '@/constants/transaction-types';
import SelectBox from '@/components/SelectBox';

export default {

  name: 'view-points-modal',
  TRANSACTION_TYPES,
  provide () {
    return {
      $menu: this.$data,
    };
  },
  components: {
    HeaderMenuChevron,
    SelectBox,
  },
  props: {
    closeIcon: {
      type: Boolean,
      default: true,
    },
    initFilter: {
      type: Object,
      default: () => {},
    },
    months: {
      type: Array,
      required: true,
    },
    selectedMonth: {
      type: Date,
      required: true,
    },
  },
  data () {
    return {
      isOpen: false,
      dataObj: {
        selectedMonth: null,
        selectedPointTypes: [],
      },
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'serviceProviderCatalogOccupations',
    ]),
    transactionTypes () {
      return this.$options.TRANSACTION_TYPES;
    },
    isDisabled () {
      return this.initFilter.selectedMonth === this.dataObj.selectedMonth
      && !this.dataObj.selectedPointTypes.length;
    },
  },
  watch: {
    initFilter: {
      immediate: true,
      handler (val) {
        this.init(val);
      },
    },
  },
  methods: {
    submit (data) {
      const filters = this.transactionTypes.filter((type) => {
        return data.selectedPointTypes.includes(type.type);
      });
      this.$events.$emit(this.$events.POINTS_FILTER_APPLY_CLICK, { filters });
      this.$emit('filter', {
        data,
      });
    },
    reset () {
      this.dataObj.selectedMonth = this.selectedMonth;
      this.dataObj.sorting = 'created_dtm desc';
      this.dataObj.selectedPointTypes = [];
      this.submit(this.dataObj);
    },
    init (data) {
      if (data && Object.keys(data).length) {
        Object.keys(data).forEach((d) => {
          this.dataObj[d] = data[d];
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
 @import "~@homeservices/design-kit/tools";

  $border: 1px solid $color-gray40;
  .MODAL {
    @include desktop {
      position: absolute;
      top: 119px;
      right: 0px;
      height: 100%;
      padding-bottom: $unit;
    }
    @include tablet {
      max-width: 400px;
    }
    border: 2px $color-gray50 solid;
    background-color: white;
  }
  .CONTENT {
    background-color: white;
    padding: 0;
  }
  #FILTERS {
    padding:  0 $unit * 2;
    margin: auto;
  }
  .BUTTONS {
    display: flex;
    justify-content: end;
    padding-bottom: $unit;
    .BUTTON {
      margin: $unit;
      padding: $unit $unit * 2;
      border-radius: 2px;
      border: solid 1px $color-gray50;
    }
  }
  .FOOTER {
    background-color: white;
  }
  .GRAYED {
    color:$color-gray40;
  }
  .LABEL {
    font-weight: 600;
  }
  .CHECK-INPUT {
    padding: $unit 2*$unit;
    line-height: 24px;
  }
  .input-check {
    transform: scale(1.3);
    margin-right: $unit;
    accent-color:$color-depot;
  }

</style>
